import { Box, Paper, Skeleton } from "@mui/material";

const ImportSettingsSkeleton = () => {
  return (
    <Box px={2} py={1}>
      {/* Header */}
      <Skeleton variant="text" width={140} height={32} />
      <Skeleton variant="text" width={90} height={20} sx={{ mb: 1.5 }} />

      {/* Cards */}
      <Box display="flex" flexDirection="column" gap={1.5}>
        {[1, 2, 3].map((i) => (
          <Paper
            key={i}
            sx={{
              boxShadow: "none",
              border: "1px solid #0000001F",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            {/* Row 1: Raw Table ID | Collection Type | Report Name | Details */}
            <Box
              display="grid"
              gridTemplateColumns="1fr 1fr 1fr auto"
              alignItems="center"
              px={2}
              py={1.5}
              gap={2}
            >
              <Box>
                <Skeleton variant="text" width={80} height={16} />
                <Skeleton variant="text" width={50} height={20} />
              </Box>
              <Box>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width={70} height={20} />
              </Box>
              <Box>
                <Skeleton variant="text" width={90} height={16} />
                <Skeleton variant="text" width={160} height={20} />
              </Box>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Skeleton variant="text" width={45} height={20} />
                <Skeleton variant="circular" width={20} height={20} />
              </Box>
            </Box>

            {/* Expanded detail rows — only first card */}
            {i === 1 && (
              <>
                <Box sx={{ borderTop: "1px solid #0000001F" }}>
                  <Box
                    display="grid"
                    gridTemplateColumns="1fr 1fr 1fr 1fr"
                    px={2}
                    py={1.5}
                    gap={2}
                  >
                    {[120, 80, 130, 150].map((w, idx) => (
                      <Box key={idx}>
                        <Skeleton variant="text" width={w} height={16} />
                        <Skeleton variant="text" width={w - 20} height={20} />
                      </Box>
                    ))}
                  </Box>
                </Box>

                <Box sx={{ borderTop: "1px solid #0000001F" }}>
                  <Box px={2} pt={1} pb={0.5}>
                    <Skeleton variant="text" width={60} height={20} />
                  </Box>
                  {/* Object table header */}
                  <Box
                    display="grid"
                    gridTemplateColumns="1fr 1fr 1fr"
                    px={2}
                    py={0.5}
                    gap={2}
                  >
                    {[60, 80, 90].map((w, idx) => (
                      <Skeleton key={idx} variant="text" width={w} height={16} />
                    ))}
                  </Box>
                  {/* Object rows */}
                  {[1, 2, 3, 4, 5].map((r) => (
                    <Box
                      key={r}
                      display="grid"
                      gridTemplateColumns="1fr 1fr 1fr"
                      px={2}
                      py={0.75}
                      gap={2}
                      sx={{ borderTop: "1px solid #0000001F" }}
                    >
                      {[80, 160, 300].map((w, idx) => (
                        <Skeleton key={idx} variant="text" width={w} height={18} />
                      ))}
                    </Box>
                  ))}
                </Box>
              </>
            )}
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default ImportSettingsSkeleton;